import { Navigate } from "react-router-dom";
import { useTimeOffAccess } from "@/hooks/useTimeOffAccess";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

interface TimeOffGuardProps {
  children: React.ReactNode;
}

export function TimeOffGuard({ children }: TimeOffGuardProps) {
  const { hasTimeOffAccess, isLoading } = useTimeOffAccess();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!hasTimeOffAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
